module.exports = __webpack_public_path__ + "static/motion-1-ab30206fc43c97edea780f71b4980d84.mp4";